import {BillItemApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";

export default class BillItem {

	constructor(public readonly amount: number,
		public readonly accountId: string,
		public readonly description: string,
		public readonly discount: Option<number>,
		public readonly quantity: number,
		public readonly taxRate: number,
		public readonly unitPrice: number) {}

	static fromJson(json: BillItemApiDto): BillItem {
		return new BillItem(json.amount, json.accountId, json.description, option(json.discount),
			json.quantity, json.taxRate, json.unitPrice);
	}
}
